import axios from 'axios'
import { api_lp, api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'
import router from '../../router'
import moment from 'moment'

const kpiStore = {
  namespaced: true,
  state: () => ({
    date_range: 0,
    start: moment()
      .subtract(12, 'months')
      .format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD'),
    query: '',

    tiket_selesai: 0,
    responden: 0,
    system_responden: 0,
    not_yet_assessed: 0,
    on_progress: 0,
    reject: 0,
    puas: 0,
    sangat_puas: 0,
    cukup_puas: 0,
    buruk: 0,
    sangat_buruk: 0,
    tidak_puas: 0,

    slaData: [],
    ssiCount: {},
    ssiChartTotalPo: [],
    ssiChartTotalPoAmount: [],
    ssiChartTop10Vendor: [],

    count_loading: false,
    sla_loading: false,
    ssi_chart_loading: false,
    ssi_count_loading: false,
    active_page: 'for_isupplier',

    modal_default: false,
    modal_reg_sap: false,
    modal_ext: false,
    modal_k3l: false,
    modal_kplh: false,
    modal_csi: false,

    for_isupplier_value: {},
    for_sap_value: {},
    for_extend_sap_value: {},
    for_k3l_value: {},
    for_kplh_value: {},
    for_csi_value: {
      startL5Responden: 80,
      endL5Responden: 100,
      startL4Responden: 70,
      endL4Responden: 79,
      startL3Responden: 0,
      endL3Responden: 69,
      startL2Responden: 0,
      endL2Responden: 0,
      startL1Responden: 0,
      endL1Responden: 0,
      startL5Nilai: 85,
      endL5Nilai: 100,
      startL4Nilai: 75,
      endL4Nilai: 84,
      startL3Nilai: 64,
      endL3Nilai: 74,
      startL2Nilai: 50,
      endL2Nilai: 64,
      startL1Nilai: 0,
      endL1Nilai: 49,
    },
    for_ssi_gems: null,
    for_ssi_bce: null,
    export: [],
  }),
  mutations: {
    UPDATE_DATA(state, payload) {
      state[payload.name] = payload.value
    },
    DEFAULT_COUNT(state, payload) {
      state.tiket_selesai = 0
      state.responden = 0
      state.system_responden = 0
      state.not_yet_assessed = 0
      state.on_progress = 0
      state.reject = 0
      state.puas = 0
      state.sangat_puas = 0
      state.cukup_puas = 0
      state.buruk = 0
      state.sangat_buruk = 0
    },
    UPDATE_COUNT(state, payload) {
      state.tiket_selesai = payload.tiket_selesai
      state.responden = payload.responden == '-' ? '-' : payload.responden
      state.system_responden =
        payload.system_responden == '-' ? '-' : payload.system_responden
      state.not_yet_assessed =
        payload.not_yet_assessed == '-' ? '-' : payload.not_yet_assessed
      state.on_progress = payload.on_progress
      state.reject = payload.reject
      state.puas = payload.puas
      state.sangat_puas = payload.sangat_puas
      state.cukup_puas = payload.cukup_puas
      state.buruk = payload.buruk
      state.sangat_buruk = payload.sangat_buruk
    },
  },
  actions: {
    getCount: async ({ commit, state, rootState }, payload) => {
      const { start, end, active_page } = state
      await commit('UPDATE_DATA', { name: 'count_loading', value: true })
      await commit('DEFAULT_COUNT')

      let url = `${api}/api/v1/dashboard-kpi/count-progress?${active_page}=1`
      if (start && end) url += `&start=${start}&end=${end}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_COUNT', data.data)
          await commit('UPDATE_DATA', {
            name: 'count_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'count_loading',
          value: false,
        })
      }
    },

    slaCalc: async ({ commit, state, rootState }, payload) => {
      const { start, end, active_page } = state
      await commit('UPDATE_DATA', { name: 'sla_loading', value: true })
      state.slaData = []

      let url = `${api}/api/v1/dashboard-kpi/sla?${active_page}=1`
      if (start && end) url += `&start=${start}&end=${end}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          state.slaData = data.data
          await commit('UPDATE_DATA', {
            name: 'sla_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'sla_loading',
          value: false,
        })
      }
    },

    exportData: async ({ commit, state, rootState }, payload) => {
      const { start, end, active_page } = state

      await commit('UPDATE_DATA', { name: 'sla_loading', value: true })
      state.export = []

      let url = `${api}/api/v1/dashboard-kpi/export?${active_page}=1`
      if (start && end) url += `&start=${start}&end=${end}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          state.export = data.data
          await commit('UPDATE_DATA', {
            name: 'sla_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'sla_loading',
          value: false,
        })
      }
    },

    filterDate: async ({ dispatch, commit, state, rootState }, payload) => {
      if (
        state.active_page == 'for_isupplier' ||
        state.active_page == 'for_sap' ||
        state.active_page == 'for_extend_sap' ||
        state.active_page == 'for_k3l' ||
        state.active_page == 'for_kplh' ||
        state.active_page == 'for_csi'
      ) {
        await dispatch('getCount')
        await dispatch('slaCalc')
      }
    },

    ssiCount: async ({ commit, state, rootState }, payload) => {
      const { start, end, active_page } = state
      await commit('UPDATE_DATA', { name: 'ssi_count_loading', value: true })
      state.ssiCount = {}

      let url = `${api}/api/v1/dashboard-kpi/ssi-count?${active_page}=1`
      if (start && end) url += `&start=${start}&end=${end}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          state.ssiCount = data.data
          await commit('UPDATE_DATA', {
            name: 'ssi_count_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'ssi_count_loading',
          value: false,
        })
      }
    },

    ssiChart: async ({ commit, state, rootState }, payload) => {
      const { start, end, active_page } = state
      await commit('UPDATE_DATA', { name: 'ssi_chart_loading', value: true })
      state.ssiChart = []

      let url = `${api}/api/v1/dashboard-kpi/ssi-chart?${active_page}=1`
      if (start && end) url += `&start=${start}&end=${end}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          state.ssiChartTotalPo = data.data && data.data.total_po
          state.ssiChartTotalPoAmount = data.data && data.data.total_po_amount
          state.ssiChartTop10Vendor = data.data && data.data.top_10_vendors

          await commit('UPDATE_DATA', {
            name: 'ssi_chart_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'ssi_chart_loading',
          value: false,
        })
      }
    },

    filterSSI: async ({ dispatch, commit, state, rootState }, payload) => {
      if (
        state.active_page == 'for_ssi_gems' ||
        state.active_page == 'for_ssi_bce'
      ) {
        await dispatch('ssiCount')
        await dispatch('ssiChart')
      }
    },

    sendSingleMail: async ({ commit, state, rootState }, payload) => {
      try {
        await commit('UPDATE_DATA', {
          name: 'ssi_count_loading',
          value: true,
        })
        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/dashboard-kpi/send-single-mail`,
          data: payload,
        })

        let pic = ''
        if (payload.STATUS_PIC == 1) {
          pic = payload.PIC_2
        } else {
          pic = payload.PIC_1
        }

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'ssi_count_loading',
            value: false,
          })
          await commit('SET_NOTIF', `Email berhasil dikirim ke : ${pic}`, {
            root: true,
          })
          return data.data
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'ssi_count_loading',
          value: false,
        })
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
      }
    },
  },
}

export default kpiStore
